module.exports = __webpack_public_path__ + "static/media/upload-icon.bf95534c.svg";